<template>
  <div id="LayerOut">
    <div v-for="(cache, index) in cachetDate" :key="index">
      <div class="cacheImg" :style="{ top: cache.y, left: cache.x }">
        <img :src="cache.imgUrl" />
      </div>
    </div>
    <div id="droppalbe" class="bg2 ui-droppable">
      <div id="page1">
        <div id="apDiv9">
          <input
            :value="aBill.t4"
            tabindex="0"
            size="4"
            name="A[0].t4"
            cname="t4"
            billdatetype="t"
            class="init_no1"
            oninput="setEncrypt()"
            onpropertychange="setEncrypt()"
          />
        </div>
        <div class="" id="apDiv1" innerinput="t1">
          <input
            :value="aBill.t1"
            tabindex="1"
            size="4"
            name="A[0].t1"
            cname="t1"
            billdatetype="t"
            class="init_city"
            style="color: #308a31; text-align: right; font-size: 24px; font-weight: unset; font-family: 楷体"
          />
        </div>
        <div class="" id="apDiv2" innerinput="t2">
          <input
            :value="aBill.t2"
            tabindex="3"
            size="4"
            name="A[0].t2"
            cname="t2"
            billdatetype="t"
            class="zzszyfp_no"
            oninput="setEncrypt()"
            onpropertychange="setEncrypt()"
          />
        </div>
        <div class="" id="apDiv3" innerinput="t3">
          <input
            :value="aBill.t3"
            tabindex="2"
            size="4"
            name="A[0].t3"
            cname="t3"
            billdatetype="t"
            class="cache_city"
            style="font-family: 楷体; font-size: 11px; color: #f94c3c; constter-spacing: -1px; text-align: center"
            id="t3"
          />
        </div>
        <!-- <div class="" id="apDiv68" innerinput="a28">
          <input
            :value="aBill.a28"
            name="A[0].a28"
            cname="a28"
            type="text"
            size="4"
            style="font-size: 20px; font-weight: bold; line-height: 22px"
          />
        </div> -->
        <div id="npDiv4" style="font-size: 9px">
          <textarea
            :value="aBill.t5"
            name="A[0].t5"
            cname="t5"
            id="t5"
            class="cache_city"
            rows="5"
            cols="20"
            size="4"
            style="
              color: #3e66a3;
              font-size: 16px;
              height: 83px;
              width: 287px;
              resize: none;
              constter-spacing: 1px;
              line-height: 21px;
            "
          ></textarea>
        </div>
        <div class="" id="apDiv5" innerinput="a96">
          <input
            :value="aBill.a96"
            tabindex="8"
            size="4"
            name="A[0].a96"
            cname="a96"
            billdatetype="t"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv6" innerinput="a5">
          <input
            :value="aBill.a5"
            tabindex="7"
            size="4"
            name="A[0].a5"
            cname="a5"
            billdatetype="t"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv7" innerinput="a4">
          <input
            :value="aBill.a4"
            tabindex="6"
            size="4"
            name="A[0].a4"
            cname="a4"
            billdatetype="n"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv8" innerinput="a3">
          <input
            :value="aBill.a3"
            tabindex="5"
            size="4"
            name="A[0].a3"
            cname="a3"
            billdatetype="t"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div id="npDiv70" style="color: #1243ce">
          <input
            :value="aBill.a40"
            tabindex="6"
            size="4"
            name="A[0].a40"
            cname="a40"
            billdatetype="n"
            style="font-size: 10px; color: #1243ce; text-align: right"
          />
        </div>
        <div id="npDiv71" style="color: #1243ce">
          <input
            :value="aBill.a41"
            tabindex="6"
            size="4"
            name="A[0].a41"
            cname="a41"
            billdatetype="n"
            style="font-size: 14px; color: #1243ce; text-align: right; constter-spacing: 1px"
          />
        </div>
        <div class="" id="apDiv12" innerinput="b1">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b1"
            tabindex="9"
            size="4"
            name="B[0].b1"
            cname="b1"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv11" innerinput="b1">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b1"
            tabindex="17"
            size="4"
            name="B[1].b1"
            cname="b1"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv10" innerinput="b1">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b1"
            tabindex="25"
            size="4"
            name="B[2].b1"
            cname="b1"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv4" innerinput="b1">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b1"
            tabindex="33"
            size="4"
            name="B[3].b1"
            cname="b1"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv14" innerinput="b1">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b1"
            tabindex="41"
            size="4"
            name="B[4].b1"
            cname="b1"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv13" innerinput="A[0].a14">
          <input
            :value="aBill.a14"
            tabindex="4"
            size="4"
            name="A[0].a14"
            cname="a14"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv67" style="width: 250px">
          <span style="color: #1243ce; font-size: 12px"
            >校验码&nbsp;<input
              :value="aBill.a50"
              name="A[0].a50"
              cname="a50"
              style="font-size: 12px; color: #1243ce; line-height: 15px; width: 180px"
            />
          </span>
        </div>
        <div class="" id="apDiv15" innerinput="b6">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b6"
            tabindex="14"
            size="4"
            name="B[0].b6"
            cname="b6"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv41" innerinput="b6">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b6"
            tabindex="22"
            size="4"
            name="B[1].b6"
            cname="b6"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv40" innerinput="b6">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b6"
            tabindex="30"
            size="4"
            name="B[2].b6"
            cname="b6"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv39" innerinput="b6">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b6"
            tabindex="38"
            size="4"
            name="B[3].b6"
            cname="b6"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv38" innerinput="b6">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b6"
            tabindex="46"
            size="4"
            name="B[4].b6"
            cname="b6"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv16" innerinput="b5">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b5"
            tabindex="13"
            size="4"
            name="B[0].b5"
            cname="b5"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv37" innerinput="b5">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b6"
            tabindex="21"
            size="4"
            name="B[1].b5"
            cname="b5"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv36" innerinput="b5">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b5"
            tabindex="29"
            size="4"
            name="B[2].b5"
            cname="b5"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv35" innerinput="b5">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b5"
            tabindex="37"
            size="4"
            name="B[3].b5"
            cname="b5"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv34" innerinput="b5">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b5"
            tabindex="45"
            size="4"
            name="B[4].b5"
            cname="b5"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv17" innerinput="b4">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b4"
            tabindex="12"
            size="4"
            name="B[0].b4"
            cname="b4"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv33" innerinput="b4">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b4"
            tabindex="20"
            size="4"
            name="B[1].b4"
            cname="b4"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv32" innerinput="b4">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b4"
            tabindex="28"
            size="4"
            name="B[2].b4"
            cname="b4"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv31" innerinput="b4">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b4"
            tabindex="36"
            size="4"
            name="B[3].b4"
            cname="b4"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv30" innerinput="b4">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b4"
            tabindex="44"
            size="4"
            name="B[4].b4"
            cname="b4"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv18" innerinput="b3">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b3"
            tabindex="11"
            size="4"
            name="B[0].b3"
            cname="b3"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv29" innerinput="b3">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b3"
            tabindex="19"
            size="4"
            name="B[1].b3"
            cname="b3"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv28" innerinput="b3">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b3"
            tabindex="27"
            size="4"
            name="B[2].b3"
            cname="b3"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv27" innerinput="b3">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b3"
            tabindex="35"
            size="4"
            name="B[3].b3"
            cname="b3"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv26" innerinput="b3">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b3"
            tabindex="43"
            size="4"
            name="B[4].b3"
            cname="b3"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv19" innerinput="b2">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b2"
            tabindex="10"
            size="4"
            name="B[0].b2"
            cname="b2"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv25" innerinput="b2">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b2"
            tabindex="18"
            size="4"
            name="B[1].b2"
            cname="b2"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv24" innerinput="b2">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b2"
            tabindex="26"
            size="4"
            name="B[2].b2"
            cname="b2"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv23" innerinput="b2">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b2"
            tabindex="34"
            size="4"
            name="B[3].b2"
            cname="b2"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv22" innerinput="b2">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b2"
            tabindex="42"
            size="4"
            name="B[4].b2"
            cname="b2"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv20" innerinput="b8">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b8"
            tabindex="16"
            size="4"
            name="B[0].b8"
            cname="b8"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv49" innerinput="b8">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b8"
            tabindex="16"
            size="4"
            name="B[1].b8"
            cname="b8"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv48" innerinput="b8">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b8"
            tabindex="16"
            size="4"
            name="B[2].b8"
            cname="b8"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv47" innerinput="b8">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b8"
            tabindex="16"
            size="4"
            name="B[3].b8"
            cname="b8"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv46" innerinput="b8">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b8"
            tabindex="16"
            size="4"
            name="B[4].b8"
            cname="b8"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv21" innerinput="b7">
          <input
            :value="bDataList[0] == null ? '' : bDataList[0].b7"
            tabindex="15"
            size="4"
            name="B[0].b7"
            cname="b7"
            billdatetype="n"
            style="color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv45" innerinput="b7">
          <input
            :value="bDataList[1] == null ? '' : bDataList[1].b7"
            tabindex="23"
            size="4"
            name="B[1].b7"
            cname="b7"
            billdatetype="n"
            style="color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv44" innerinput="b7">
          <input
            :value="bDataList[2] == null ? '' : bDataList[2].b7"
            tabindex="31"
            size="4"
            name="B[2].b7"
            cname="b7"
            billdatetype="n"
            style="color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv43" innerinput="b7">
          <input
            :value="bDataList[3] == null ? '' : bDataList[3].b7"
            tabindex="39"
            size="4"
            name="B[3].b7"
            cname="b7"
            billdatetype="n"
            style="color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv42" innerinput="b7">
          <input
            :value="bDataList[4] == null ? '' : bDataList[4].b7"
            tabindex="47"
            size="4"
            name="B[4].b7"
            cname="b7"
            billdatetype="n"
            style="color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv50" innerinput="a21">
          <input
            :value="aBill.a21"
            tabindex="50"
            size="4"
            name="A[0].a21"
            cname="a21"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv51" innerinput="a20">
          <input
            :value="aBill.a20"
            tabindex="49"
            size="4"
            name="A[0].a20"
            cname="a20"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv52" innerinput="a25">
          <input
            :value="aBill.a25"
            tabindex="54"
            size="4"
            name="A[0].a25"
            cname="a25"
            billdatetype="n"
            style="text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv53" innerinput="a24">
          <input
            :value="aBill.a24"
            tabindex="53"
            size="4"
            name="A[0].a24"
            cname="a24"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv54" innerinput="a23">
          <input
            :value="aBill.a23"
            tabindex="52"
            size="4"
            name="A[0].a23"
            cname="a23"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce; text-align: right"
          />
        </div>
        <div class="" id="apDiv55" innerinput="a22">
          <input
            :value="aBill.a22"
            tabindex="51"
            size="4"
            name="A[0].a22"
            cname="a22"
            billdatetype="n"
            style="text-align: right; font-size: 12px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv56" innerinput="a26">
          <input
            :value="aBill.a26"
            tabindex="16"
            size="4"
            name="A[0].a26"
            cname="a26"
            billdatetype="n"
            style="font-size: 12px; text-align: right; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv57" innerinput="a12">
          <input
            :value="aBill.a12"
            tabindex="57"
            size="4"
            name="A[0].a12"
            cname="a12"
            billdatetype="n"
            style="font-size: 12px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv58" innerinput="a11">
          <input
            :value="aBill.a11"
            tabindex="56"
            size="4"
            name="A[0].a11"
            cname="a11"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv59" innerinput="a97">
          <input
            :value="aBill.a97"
            tabindex="61"
            size="4"
            name="A[0].a97"
            cname="a97"
            billdatetype="t"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv60" innerinput="a9">
          <input
            :value="aBill.a9"
            tabindex="60"
            size="4"
            name="A[0].a9"
            cname="a9"
            billdatetype="t"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv61" innerinput="a8">
          <input
            :value="aBill.a8"
            tabindex="59"
            size="4"
            name="A[0].a8"
            cname="a8"
            billdatetype="n"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv62" innerinput="a7">
          <input
            :value="aBill.a7"
            tabindex="58"
            size="4"
            name="A[0].a7"
            cname="a7"
            billdatetype="t"
            style="padding: 0px; color: #1243ce"
          />
        </div>
        <div class="" id="apDiv63" innerinput="a98">
          <textarea
            :value="aBill.a98"
            tabindex="62"
            rows="4"
            name="A[0].a98"
            cname="a98"
            billdatetype="t"
            style="color: #1243ce; width: 270px; height: 74px; resize: none"
          ></textarea>
        </div>
        <div class="" id="apDiv64" innerinput="a19">
          <input
            :value="aBill.a19"
            tabindex="65"
            size="4"
            name="A[0].a19"
            cname="a19"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv65" innerinput="a18">
          <input
            :value="aBill.a18"
            tabindex="64"
            size="4"
            name="A[0].a18"
            cname="a18"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
        <div class="" id="apDiv66" innerinput="a17">
          <input
            :value="aBill.a17"
            tabindex="63"
            size="4"
            name="A[0].a17"
            cname="a17"
            billdatetype="t"
            style="color: #1243ce"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      cachetDate: [],
      aDataList: [],
      bDataList: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      const cacheList = []
      const bDataList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          this.aBill = this.bgDatas[index]['a']
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const cl = this.bgDatas[index]['c']
          for (const jIndex in cl) {
            const c = cl[jIndex]
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + c.imgUrl
            t.x = c.x + 'px'
            t.y = c.y + 'px'
            cacheList.push(t)
            break //   暂时只取一个
          }
        } else if (this.bgDatas[index]['b'] !== undefined) {
          const bl = this.bgDatas[index]['b']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            const t = {
              b1: '',
              b2: '',
              b3: '',
              b4: '',
              b5: '',
              b6: '',
              b7: '',
              b8: '',
            }
            t.b1 = b.b1
            t.b2 = b.b2
            t.b3 = b.b3
            t.b4 = b.b4
            t.b5 = b.b5
            t.b6 = b.b6
            t.b7 = b.b7
            t.b8 = b.b8
            bDataList.push(t)
          }
        }
      }
      this.bDataList = bDataList
      this.cachetDate = cacheList
    },
  },
}
</script>

<style lang="less" scoped>
#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
  width: 925px;
  height: 539px;
}
.bg1 {
  background: url('https://accfun-pic.oss-cn-hangzhou.aliyuncs.com/common/odiv/odiv_zzszyfp/V4/odiv_zzszyfpA.png?x-oss-process=style/sc-common');
  position: relative;
  z-index: 1;
  width: 925px;
  height: 539px;
  top: 0px;
  left: 0px;
  clear: both;
}
.bg2 {
  background: url('~@/assets/odiv_zzszyfpB.png');
  position: relative;
  z-index: 1;
  width: 925px;
  height: 539px;
  top: 0px;
  left: 0px;
  clear: both;
}
.bg3 {
  background: url('https://accfun-pic.oss-cn-hangzhou.aliyuncs.com/common/odiv/odiv_zzszyfp/V4/odiv_zzszyfpC.png?x-oss-process=style/sc-common');
  position: relative;
  z-index: 1;
  width: 925px;
  height: 539px;
  top: 0px;
  left: 0px;
  clear: both;
}
#page1 {
  position: relative;
  z-index: 3;
  width: 925px;
  height: 539px;
}
input.zzszyfp_no {
  font-size: 24px;
  font-family: '黑体';
  font-weight: bold;
  color: #3868ee;
}
input.init_city {
  font-size: 24px;
  text-align: right;
  font-weight: bold;
  line-height: 22px;
  vertical-align: middle;
  color: #bda648;
}
input.cache_city {
  font-size: 10px;
  font-family: '楷体_GB2312', '楷体';
  color: #fa4b3b;
}
input.init_no1 {
  font-size: 24px;
  font-family: '黑体', '宋体';
  color: #000;
}
#apDiv1 {
  position: absolute;
  left: 310px;
  top: 27px !important;
  *top: 27px !important;
  top: 27px;
  width: 80px;
  height: 24px;
  z-index: 4;
}
#apDiv2 {
  position: absolute;
  left: 641px;
  top: 36px;
  width: 130px;
  height: 33px;
  z-index: 4;
}
#apDiv3 {
  position: absolute;
  left: 421px;
  top: 83px;
  width: 37px;
  height: 17px;
  z-index: 4;
  transform: rotate(11deg);
  -ms-transform: rotate(11deg);
  /* IE 9 */
  -moz-transform: rotate(11deg);
  /* Firefox */
  -webkit-transform: rotate(11deg);
  /* Safari �� Chrome */
  -o-transform: rotate(11deg);
  /* Opera */
}
#npDiv4 {
  position: absolute;
  left: 568px;
  top: 113px;
  width: 288px;
  height: 85px;
  z-index: 4;
}
#apDiv5 {
  position: absolute;
  left: 188px;
  top: 180px;
  width: 345px;
  height: 16px;
  z-index: 4;
}
#apDiv6 {
  position: absolute;
  left: 188px;
  top: 158px;
  width: 345px;
  height: 16px;
  z-index: 4;
}
#apDiv7 {
  position: absolute;
  left: 188px;
  top: 137px;
  width: 345px;
  height: 16px;
  z-index: 4;
}
#apDiv8 {
  position: absolute;
  left: 188px;
  top: 117px;
  width: 345px;
  height: 16px;
  z-index: 4;
}
#npDiv9 {
  position: absolute;
  left: 733px;
  top: 135px;
  width: 84px;
  height: 15px;
  z-index: 4;
}
#apDiv4 {
  position: absolute;
  left: 70px;
  top: 285px;
  width: 175px;
  height: 18px;
  z-index: 4;
}
#apDiv10 {
  position: absolute;
  left: 70px;
  top: 265px;
  width: 175px;
  height: 18px;
  z-index: 4;
}
#apDiv11 {
  position: absolute;
  left: 70px;
  top: 245px;
  width: 175px;
  height: 18px;
  z-index: 4;
}
#apDiv12 {
  position: absolute;
  left: 70px;
  top: 225px;
  width: 175px;
  height: 18px;
  z-index: 4;
}
#apDiv13 {
  position: absolute;
  left: 710px;
  top: 89px;
  width: 108px;
  height: 16px;
  z-index: 4;
}
#apDiv14 {
  position: absolute;
  left: 70px;
  top: 305px;
  width: 175px;
  height: 18px;
  z-index: 4;
}
#apDiv15 {
  position: absolute;
  left: 563px;
  top: 225px;
  width: 115px;
  height: 18px;
  z-index: 4;
}
#apDiv16 {
  position: absolute;
  left: 459px;
  top: 225px;
  width: 101px;
  height: 18px;
  z-index: 4;
}
#apDiv17 {
  position: absolute;
  left: 386px;
  top: 225px;
  width: 70px;
  height: 18px;
  z-index: 4;
}
#apDiv18 {
  position: absolute;
  left: 338px;
  top: 225px;
  width: 45px;
  height: 18px;
  z-index: 4;
}
#apDiv19 {
  position: absolute;
  left: 250px;
  top: 225px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv20 {
  position: absolute;
  left: 715px;
  top: 225px;
  width: 140px;
  height: 18px;
  z-index: 4;
}
#apDiv21 {
  position: absolute;
  left: 681px;
  top: 225px;
  width: 31px;
  height: 18px;
  z-index: 4;
}
#apDiv22 {
  position: absolute;
  left: 250px;
  top: 305px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv23 {
  position: absolute;
  left: 250px;
  top: 285px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv24 {
  position: absolute;
  left: 250px;
  top: 265px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv25 {
  position: absolute;
  left: 250px;
  top: 245px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv26 {
  position: absolute;
  left: 338px;
  top: 305px;
  width: 45px;
  height: 18px;
  z-index: 4;
}
#apDiv27 {
  position: absolute;
  left: 338px;
  top: 285px;
  width: 45px;
  height: 18px;
  z-index: 4;
}
#apDiv28 {
  position: absolute;
  left: 338px;
  top: 265px;
  width: 45px;
  height: 18px;
  z-index: 4;
}
#apDiv29 {
  position: absolute;
  left: 338px;
  top: 245px;
  width: 45px;
  height: 18px;
  z-index: 4;
}
#apDiv30 {
  position: absolute;
  left: 386px;
  top: 305px;
  width: 70px;
  height: 18px;
  z-index: 4;
}
#apDiv31 {
  position: absolute;
  left: 386px;
  top: 285px;
  width: 70px;
  height: 18px;
  z-index: 4;
}
#apDiv32 {
  position: absolute;
  left: 386px;
  top: 265px;
  width: 70px;
  height: 18px;
  z-index: 4;
}
#apDiv33 {
  position: absolute;
  left: 386px;
  top: 245px;
  width: 70px;
  height: 18px;
  z-index: 4;
}
#apDiv34 {
  position: absolute;
  left: 459px;
  top: 305px;
  width: 101px;
  height: 18px;
  z-index: 4;
}
#apDiv35 {
  position: absolute;
  left: 459px;
  top: 285px;
  width: 101px;
  height: 18px;
  z-index: 4;
}
#apDiv36 {
  position: absolute;
  left: 459px;
  top: 265px;
  width: 101px;
  height: 18px;
  z-index: 4;
}
#apDiv37 {
  position: absolute;
  left: 459px;
  top: 245px;
  width: 101px;
  height: 18px;
  z-index: 4;
}
#apDiv38 {
  position: absolute;
  left: 563px;
  top: 305px;
  width: 115px;
  height: 18px;
  z-index: 4;
}
#apDiv39 {
  position: absolute;
  left: 563px;
  top: 285px;
  width: 115px;
  height: 18px;
  z-index: 4;
}
#apDiv40 {
  position: absolute;
  left: 563px;
  top: 265px;
  width: 115px;
  height: 18px;
  z-index: 4;
}
#apDiv41 {
  position: absolute;
  left: 563px;
  top: 245px;
  width: 115px;
  height: 18px;
  z-index: 4;
}
#apDiv42 {
  position: absolute;
  left: 681px;
  top: 305px;
  width: 31px;
  height: 18px;
  z-index: 4;
}
#apDiv43 {
  position: absolute;
  left: 681px;
  top: 285px;
  width: 31px;
  height: 18px;
  z-index: 4;
}
#apDiv44 {
  position: absolute;
  left: 681px;
  top: 265px;
  width: 31px;
  height: 18px;
  z-index: 4;
}
#apDiv45 {
  position: absolute;
  left: 681px;
  top: 245px;
  width: 31px;
  height: 18px;
  z-index: 4;
}
#apDiv46 {
  position: absolute;
  left: 715px;
  top: 305px;
  width: 140px;
  height: 18px;
  z-index: 4;
}
#apDiv47 {
  position: absolute;
  left: 715px;
  top: 285px;
  width: 140px;
  height: 18px;
  z-index: 4;
}
#apDiv48 {
  position: absolute;
  left: 715px;
  top: 265px;
  width: 140px;
  height: 18px;
  z-index: 4;
}
#apDiv49 {
  position: absolute;
  left: 715px;
  top: 245px;
  width: 140px;
  height: 18px;
  z-index: 4;
}
#apDiv50 {
  position: absolute;
  left: 338px;
  top: 352px;
  width: 45px;
  height: 18px;
  z-index: 4;
}
#apDiv51 {
  position: absolute;
  left: 250px;
  top: 352px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv52 {
  position: absolute;
  left: 681px;
  top: 352px;
  width: 31px;
  height: 18px;
  z-index: 4;
}
#apDiv53 {
  position: absolute;
  left: 563px;
  top: 352px;
  width: 115px;
  height: 18px;
  z-index: 4;
}
#apDiv54 {
  position: absolute;
  left: 459px;
  top: 352px;
  width: 101px;
  height: 18px;
  z-index: 4;
}
#apDiv55 {
  position: absolute;
  left: 386px;
  top: 352px;
  width: 70px;
  height: 18px;
  z-index: 4;
}
#apDiv56 {
  position: absolute;
  left: 715px;
  top: 352px;
  width: 140px;
  height: 18px;
  z-index: 4;
}
#apDiv57 {
  position: absolute;
  left: 705px;
  top: 382px;
  width: 140px;
  height: 20px;
  z-index: 4;
}
#apDiv58 {
  position: absolute;
  left: 276px;
  top: 380px;
  width: 360px;
  height: 20px;
  z-index: 4;
}
#apDiv59 {
  position: absolute;
  left: 188px;
  top: 464px;
  width: 365px;
  height: 18px;
  z-index: 4;
}
#apDiv60 {
  position: absolute;
  left: 188px;
  top: 445px;
  width: 365px;
  height: 18px;
  z-index: 4;
}
#apDiv61 {
  position: absolute;
  left: 188px;
  top: 426px;
  width: 365px;
  height: 18px;
  z-index: 4;
}
#apDiv62 {
  position: absolute;
  left: 188px;
  top: 409px;
  width: 365px;
  height: 18px;
  z-index: 4;
}
#apDiv63 {
  position: absolute;
  left: 585px;
  top: 407px;
  width: 272px;
  height: 75px;
  z-index: 4;
}
#apDiv64 {
  position: absolute;
  left: 480px;
  top: 485px;
  width: 85px;
  height: 18px;
  z-index: 4;
}
#apDiv65 {
  position: absolute;
  left: 313px;
  top: 485px;
  width: 105px;
  height: 18px;
  z-index: 4;
}
#apDiv66 {
  position: absolute;
  left: 130px;
  top: 485px;
  width: 135px;
  height: 18px;
  z-index: 4;
}
#apDiv9 {
  position: absolute;
  left: 115px;
  top: 26px;
  width: 143px;
  height: 27px;
  z-index: 4;
}
#apDiv67 {
  position: absolute;
  left: 80px;
  top: 80px;
  width: 200px;
  height: 15px;
  z-index: 4;
}
#apDiv68 {
  position: absolute;
  width: 100px;
  height: 23px;
  z-index: 5;
  left: 125px;
  top: 56px;
}
#apDiv69 {
  position: absolute;
  width: 45px;
  height: 23px;
  z-index: 4;
  left: 233px;
  top: 75px;
}
#npDiv70 {
  position: absolute;
  left: 790px;
  top: 40px;
  width: 75px;
  height: 16px;
  z-index: 4;
}
#npDiv71 {
  position: absolute;
  left: 790px;
  top: 60px;
  width: 75px;
  height: 16px;
  z-index: 4;
}
input {
  font-family: '宋体';
  font-size: 12px;
  background-color: transparent;
  background: none;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 99%;
  background-color: transparent;
}
TEXTAREA {
  font-family: '宋体';
  font-size: 12px;
  background-color: transparent;
  background: none;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 99%;
  height: 100%;
}
.cacheImg {
  position: absolute;
  z-index: 1000;
  margin-top: 30px;
}
</style>
